import { Component, Input } from '@angular/core';

import { ModalController, ToastController, AlertController, Events } from 'ionic-angular';
import { AlertMessager } from '../../../../lib/alertMessager';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/mergeMap';
import { NominationLogsPage } from './nomination-logs';
import { Organization } from '../../../../model/organization';
import { NominationService } from '../../../../services/nomination.service';
import { HorseNomination } from '../../../../model/horseNomination';
import { Nomination } from '../../../../model/nomination';
import { AccountHelper } from '../../../../lib/accountHelper';
import { NewNominationPage } from './new-nomination';
import { OrganizationService } from '../../../../services/organization.service';
import { Horse } from 'model/horse';
import { AddHorsePage } from '../../../../pages/horse/add-horse';

@Component({
    selector: 'staff-nominations',
    templateUrl: 'nominations.html'
})
export class NominationsSection {
    _organization: Organization;
    _viewMode: string = 'overview';

    organizations: Organization[];

    searchChangeObservable;
    searchQuery: string;
    searchResults: any = [];

    nominationSearchChangeObservable;
    nominationResults: HorseNomination[] = [];
    rider: string;
    ownerName: string;
    horseName: string;
    registrationId: string;
    damName: string;
    sireName: string;

    confirmation: string;
    payConfirmation: string;
    scheduleFilter: string = 'Any';

    popoverActive: boolean;
    loadingData: boolean;

    exceededResults: boolean;

    @Input()
    set organization(organization: Organization) {
        if (organization != null) {
            this._organization = organization;

            setTimeout(() => {
                this.getUpdatedNominations();
            }, 0);

            this.filterNominations();
        }
    }
    get organization(): Organization {
        return this._organization;
    }

    @Input()
    set viewMode(viewMode: string) {
        if (viewMode != null) {
            this._viewMode = viewMode;
        }
    }
    get viewMode(): string {
        return this._viewMode;
    }

    constructor(private modalCtrl: ModalController, private alertController: AlertController, private alert: AlertMessager, private events: Events,
        private toast: ToastController, private nominationService: NominationService, private organizationService: OrganizationService) {
        this.organizationService.getOrganizations()
            .then(data => {
                this.organizations = data;
            })
    }

    getUpdatedNominations() {
        let timeout = 5000;

        if (this.organization) {
            let regUpdateInfo = [];

            this.organization.nominations[0].nominations.forEach((nomination) => {
                regUpdateInfo.push({ Id: nomination.id, Updated: nomination.updated })
            });

            this.nominationService.getUpatedHorseNominations(this.organization.nominations[0].id, regUpdateInfo)
                .then(data => {

                    (data as any).update.forEach(reg => {
                        let foundReg = false;
                        for (let i = 0; i < this.organization.nominations.length; i++) {
                            if (this.organization.nominations[i].id != reg.nominationId)
                                continue;

                            for (let x = 0; x < this.organization.nominations[i].nominations.length; x++) {
                                if (this.organization.nominations[i].nominations[x].id != reg.id)
                                    continue;


                                Object.assign(this.organization.nominations[i].nominations[x], reg);
                                foundReg = true;

                                if (foundReg)
                                    break;
                            }

                            if (foundReg)
                                break;
                        }
                    });
                    this.events.publish("NominationUpdated", (data as any).update);

                    (data as any).delete.forEach(regUpdateInfo => {
                        for (let i = 0; i < this.organization.nominations.length; i++) {
                            this.organization.nominations[i].nominations = this.organization.nominations[i].nominations.filter(x => x.id != regUpdateInfo.id);
                        }
                    });
                    this.events.publish("NominationDeleted", (data as any).delete);

                    (data as any).add.forEach(reg => {
                        if (this.nominationService.deleted.some(x => x == reg.id))
                            return;

                        let foundReg = false;
                        for (let i = 0; i < this.organization.nominations.length; i++) {
                            foundReg = true;
                            if (this.organization.nominations[i].nominations.filter(x => x.id == reg.id).length == 0)
                                this.organization.nominations[i].nominations.push(reg);

                            if (foundReg)
                                break;
                        }
                    });
                    this.events.publish("NominationAdded", (data as any).add);

                    this.filterNominations();
                }).catch(error => {
                    timeout = 15000;
                });
        }

        setTimeout(() => {
            this.getUpdatedNominations();
        }, timeout);
    }

    getSearchMessage() {
        if (this.loadingData)
            return "";

        if (this.searchQuery == undefined || this.searchQuery.trim().length == 0)
            return "";
        else if (this.searchResults == undefined || this.searchResults.length < 1) {
            return "There are no nominations by that name.";
        }

        return "";
    }

    onHorseSearchChange(searchValue: string) {
        this.onNominationSearchChange('horse' + searchValue);
    }

    onSireSearchChange(searchValue: string) {
        this.onNominationSearchChange('sire' + searchValue);
    }

    onDamSearchChange(searchValue: string) {
        this.onNominationSearchChange('dam' + searchValue);
    }

    onOwnerSearchChange(searchValue: string) {
        this.onNominationSearchChange('owner' + searchValue);
    }

    onRegistrationSearchChange(searchValue: string) {
        this.onNominationSearchChange('registration' + searchValue);
    }

    onConfirmationSearchChange(searchValue: string) {
        this.onNominationSearchChange('confirmation' + searchValue);
    }

    onPayConfirmationSearchChange(searchValue: string) {
        this.onNominationSearchChange('payConfirmation' + searchValue);
    }

    onNominationSearchChange(searchValue: string) {
        if (!this.nominationSearchChangeObservable) {
            Observable.create(observer => {
                this.nominationSearchChangeObservable = observer;
            }).debounceTime(300)
                .distinctUntilChanged()
                .subscribe((text) => { this.filterNominations() });
        }

        this.nominationSearchChangeObservable.next(searchValue);
    }

    filterNominations() {
        this.nominationResults = this.organization.nominations.flatMap(x => x.nominations);

        if (this.horseName) {
            this.nominationResults = this.nominationResults.filter(x =>
                x.horse.name.toLowerCase().indexOf(this.horseName.toLocaleLowerCase()) > -1);
        }

        if (this.registrationId) {
            this.nominationResults = this.nominationResults.filter(x =>
                (x.horse.aqhaId && x.horse.aqhaId.toLowerCase().indexOf(this.registrationId) > -1)
                || (x.horse.breedRegistrationId && x.horse.breedRegistrationId.toLowerCase().indexOf(this.registrationId.toLocaleLowerCase()) > -1));
        }

        if (this.damName) {
            this.nominationResults = this.nominationResults.filter(x =>
                x.horse.dam && x.horse.dam.name.toLowerCase().indexOf(this.damName.toLocaleLowerCase()) > -1);
        }

        if (this.sireName) {
            this.nominationResults = this.nominationResults.filter(x =>
                x.horse.sire && x.horse.sire.name && x.horse.sire.name.toLowerCase().indexOf(this.sireName.toLocaleLowerCase()) > -1);
        }

        if (this.ownerName) {
            this.nominationResults = this.nominationResults.filter(x =>
                x.horse.owner && x.horse.owner.name && x.horse.owner.name.toLowerCase().indexOf(this.ownerName.toLocaleLowerCase()) > -1);
        }

        if (this.payConfirmation) {
            this.nominationResults = this.nominationResults.filter(x =>
                x.payConfirmationCode && x.payConfirmationCode && x.payConfirmationCode.toLowerCase().indexOf(this.payConfirmation.toLocaleLowerCase()) > -1);
        }

        if (this.confirmation) {
            this.nominationResults = this.nominationResults.filter(x =>
                x.confirmationCode && x.confirmationCode && x.confirmationCode.toLowerCase().indexOf(this.confirmation.toLocaleLowerCase()) > -1);
        }

        this.nominationResults = this.nominationResults.sort((n1, n2) => {
            if (n1.horse.name < n2.horse.name)
                return -1;
            else if (n1.horse.name > n2.horse.name)
                return 1;

            if (n1.horse.sire && n2.horse.sire) {
                if (n1.horse.sire.name < n2.horse.sire.name)
                    return -1;
                else if (n1.horse.sire.name > n2.horse.sire.name)
                    return 1;
            }

            if (n1.id < n2.id)
                return -1;
            else if (n1.id > n2.id)
                return 1;
        });

        this.nominationResults = this.nominationResults.slice(0, 200);
    }

    async viewNominationLogs(nomination: any) {
        if (this.popoverActive)
            return;

        this.popoverActive = true;

        let logs = await this.nominationService.getNominationLogs(nomination.id);

        let entryModal = this.modalCtrl.create(NominationLogsPage, { logs: logs }, { cssClass: 'page-nomination-logs', enableBackdropDismiss: false });

        entryModal.present();
        entryModal.onDidDismiss((data) => {
            this.popoverActive = false;
        });
    }

    async showHorseInfo(horse: Horse) {
        if (this.popoverActive)
            return;

        console.log("Showing horse: ", horse);

        this.popoverActive = true;

        let entryModal = this.modalCtrl.create(AddHorsePage, { horse: horse }, { cssClass: 'page-add-horse', enableBackdropDismiss: false });

        entryModal.present();
        entryModal.onDidDismiss((data) => {
            this.popoverActive = false;
        });
    }

    addNewNomination() {
        if (this.popoverActive)
            return;

        this.popoverActive = true;

        let entryModal = this.modalCtrl.create(NewNominationPage, { organization: this.organization, organizations: this.organizations, staff: true }, { cssClass: 'page-new-nomination', enableBackdropDismiss: false });

        entryModal.present();
        entryModal.onDidDismiss((data) => {
            this.popoverActive = false;

            if (!data && !data.nominations && data.nominations > 0) {
                data.nominations.foreach(nominationEntry => {
                    let nomination = this.organization.nominations.filter(x => x.id == nominationEntry.nominationId)[0];

                    if (nomination != null)
                        nomination.nominations.push(nominationEntry);
                });
            }
        });
    }

    editNomination(nomination: any) {
        if (this.popoverActive)
            return;

        this.popoverActive = true;

        let entryModal = this.modalCtrl.create(NewNominationPage, { organization: this.organization, organizations: this.organizations, staff: true, nomination: nomination }, { cssClass: 'page-new-nomination', enableBackdropDismiss: false });

        entryModal.present();
        entryModal.onDidDismiss((data) => {
            this.popoverActive = false;

            if (!data && !data.nominations && data.nominations > 0) {
                data.nominations.foreach(nominationEntry => {
                    let nomination = this.organization.nominations.filter(x => x.id == nominationEntry.nominationId)[0];

                    if (nomination != null)
                        nomination.nominations.filter(x => x.id == nominationEntry.id)[0] = nominationEntry;
                });
            }
        });
    }

    removeNomination(nomination: Nomination, nominationEntry: HorseNomination) {
        if (this.popoverActive)
            return;

        this.popoverActive = true;

        let alert = this.alertController.create({
            title: 'Confirm Nomination Removal',
            message: 'Do you want to remove this nomination?',
            buttons: [
                {
                    text: 'Yes',
                    handler: () => {
                        this.nominationService.deleteHorseNomination(AccountHelper.instance().getAccountId(), nominationEntry.id)
                            .then(data => {
                                if (data == null || data == undefined) {
                                    this.organization.nominations.filter(x => x.id == nomination.id)[0].nominations = this.organization.nominations.filter(x => x.id == nomination.id)[0].nominations.filter(x => x.id != nominationEntry.id)

                                    this.toast.create({
                                        message: 'Nomination was removed successfully.',
                                        duration: 1500,
                                        position: 'middle'
                                    }).present();

                                } else if ((data as any).message != null && (data as any).message != undefined) {
                                    this.alert.showError("Nomination Removal Failed", (data as any).message);
                                }
                            }, error => {
                                this.alert.showError("Entry Removal Error", error);
                            });
                    }
                },
                {
                    text: 'No',
                    role: 'cancel',
                    handler: () => { }
                }]
        });

        alert.present();

        alert.onDidDismiss(() => {
            this.popoverActive = false;
        })
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/organization/nominations/nominations.ts